import axios from "axios"; 

export const baseURL = process.env.REACT_APP_BASE_URL;

// Create an axios instance with the baseURL and default headers
const instance = axios.create({
  baseURL
});

export default instance;
